import { memo } from 'react';

interface CalendarCheckProps {
    className?: string;
    color?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

function CalendarCheck({ 
    className = '', 
    color = '#333',
    onMouseEnter,
    onMouseLeave 
}: CalendarCheckProps) {
    return (
        <svg 
            width="24" 
            height="24" 
            viewBox="0 0 48 48" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <path 
                d="M5 19H43V41C43 42.1046 42.1046 43 41 43H7C5.89543 43 5 42.1046 5 41V19Z" 
                fill={color}
                fillOpacity="0.1"
                stroke={color} 
                strokeWidth="3" 
                strokeLinejoin="round"
            />
            <path 
                d="M5 10C5 8.89543 5.89543 8 7 8H41C42.1046 8 43 8.89543 43 10V19H5V10Z" 
                fill={color}
                fillOpacity="0.15"
                stroke={color} 
                strokeWidth="3" 
                strokeLinejoin="round"
            />
            <path 
                d="M16 31L22 37L34 25" 
                stroke={color} 
                strokeWidth="4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M16 5V13" 
                stroke={color} 
                strokeWidth="3" 
                strokeLinecap="round"
            />
            <path 
                d="M32 5V13" 
                stroke={color} 
                strokeWidth="3" 
                strokeLinecap="round"
            />
        </svg>
    );
}

export default memo(CalendarCheck); 